import { styled } from '@mui/material'

export const Spacer = styled('span')({
  flexGrow: 1,
})
